// extracted by mini-css-extract-plugin
export default {"nav-link":"MenuItem_nav-link__LQA6T","active":"MenuItem_active__2H4zz","icon":"MenuItem_icon__LddNh","text":"MenuItem_text__W6uga"};